import { render, staticRenderFns } from "./SynchronizeShuttleFiles.vue?vue&type=template&id=5710d3e3&scoped=true"
import script from "./SynchronizeShuttleFiles.vue?vue&type=script&lang=js"
export * from "./SynchronizeShuttleFiles.vue?vue&type=script&lang=js"
import style0 from "./SynchronizeShuttleFiles.vue?vue&type=style&index=0&id=5710d3e3&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5710d3e3",
  null
  
)

export default component.exports